module.exports = __webpack_public_path__ + "static/media/WIX_logo.7c6545f8.png";